import { connect } from 'shared/node_modules/react-redux';
import { setAuthCallbackIntent } from 'shared/state/actions/callbackIntent';
import LinkAccount from './LinkAccount';

const mapDispatchToProps = {
  setAuthCallbackIntent,
};

export default connect(null, mapDispatchToProps)(LinkAccount);
